module.exports = __webpack_public_path__ + "static/ss3.88884718.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/studysmart/ss/ss3.png
// module id = 1199
// module chunks = 81679748166845